import auth from '../../middlewares/auth';

export const locationRoutes = [
  {
    path: '/locations',
    component: () =>
      import(
        /* webpackChunkName: "locations" */ '../../views/inventory/locations/Index'
      ),
    name: 'locations',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-location-manage'],
    },
  },
  {
    path: '/locations/:id',
    component: () =>
      import(
        /* webpackChunkName: "locations" */ '../../views/inventory/locations/Form'
      ),
    name: 'update-locations',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-location-manage'],
    },
  },
  {
    path: '/create-locations',
    component: () =>
      import(
        /* webpackChunkName: "locations" */ '../../views/inventory/locations/Form'
      ),
    name: 'create-locations',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-location-manage'],
    },
  },
];
